import { extensions } from '../../extensions/Extensions';
import { BitmapTextPipe } from './BitmapTextPipe';

extensions.add(BitmapTextPipe);
